import React from "react";
import { FormattedMessage } from "react-intl";

export const translateByMessageId = (msgId) => { 
    // some logic
    // const intl = useIntl();
   
    return <FormattedMessage id= {msgId} /> ;
  } 